var _path, _path2, _rect, _path3, _path4, _path5, _circle, _path6, _rect2, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviewNothing = function SvgReviewNothing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 120"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#reviewNothing_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M110.184 73.192c1.744 1.755 3.439 3.578 5.261 5.255 1.182 1.091 1.201 1.813 0 2.963-7.732 7.41-16.53 13.162-26.567 16.789-25.627 9.272-49.994 6.493-72.889-8.316-3.798-2.457-7.092-5.713-10.629-8.57-1.114-.907-1.153-1.628-.077-2.671 3.73-3.656 7.392-7.38 11.045-11.115.97-.975 1.638-1.101 2.723-.068 7.848 7.41 16.975 12.538 27.497 14.839 20.191 4.426 38.26-.088 53.986-13.669 2.732-2.36 2.693-2.398 5.222.127l4.418 4.445z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "reviewNothing_svg__b",
    width: 208,
    height: 113,
    x: -48,
    y: -9,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F1F2",
    d: "M60.31 103.616c-25.07 0-43.704-12.196-48.786-16.94L-48 36.492 60.31-9 159.2 31l-48.746 54.999c-16.601 14.229-40.316 17.617-50.142 17.617"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#reviewNothing_svg__b)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65.602,
    height: 45.921,
    x: 27.398,
    y: 44,
    fill: "#D7DCE4",
    rx: 6.56
  })), /*#__PURE__*/React.createElement("mask", {
    id: "reviewNothing_svg__c",
    width: 63,
    height: 66,
    x: 30,
    y: 44,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M86.222 44.219H30.86a6.56 6.56 0 0 1 6.56 6.56v52.481a6.56 6.56 0 0 0 6.56 6.56h42.242a6.56 6.56 0 0 0 6.56-6.56V50.779a6.56 6.56 0 0 0-6.56-6.56"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#reviewNothing_svg__c)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 95.579,
    cy: 54.123,
    r: 40.518,
    fill: "#B9C2D1",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#AEB8C9",
    strokeLinecap: "round",
    strokeWidth: 5.467,
    d: "M37.239 65.867h33.894M45.986 76.8H79.88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D7DCE4",
    d: "M27.398 104.136V78.988l17.494 9.294z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3,
    cy: 10.3,
    r: 12.3,
    fill: "#F45149",
    stroke: "#F0F1F2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    transform: "matrix(-1 0 0 1 96.799 79.963)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M85.09 92.77v-.326q0-1.26.638-2.163.25-.356.548-.637.296-.281.71-.608.445-.34.682-.578a1.24 1.24 0 0 0 .311-.533q.045-.177.045-.355 0-.356-.208-.652a1.46 1.46 0 0 0-.533-.4 1.5 1.5 0 0 0-.681-.163q-.712 0-1.17.34-.43.341-.608 1.023l-.074.31-2.193-.562.074-.311q.37-1.467 1.363-2.222 1.008-.77 2.578-.77a4.6 4.6 0 0 1 1.555.251q.713.252 1.215.755.489.46.741 1.112.267.637.267 1.363 0 .622-.222 1.096a2.7 2.7 0 0 1-.519.8q-.296.326-.8.77-.666.563-.993 1.022-.31.445-.31 1.126v.326zm1.29 3.481q-.579 0-.993-.415-.4-.4-.4-1.007 0-.578.4-.978.414-.415.992-.415t.993.415q.415.4.415.978 0 .577-.4 1.007a1.37 1.37 0 0 1-1.008.415"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 27.158,
    fill: "#E3E7ED",
    rx: 6.789,
    transform: "matrix(-1 0 0 1 103 27)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M103 55.533v-7.819c0-1.7-1.806-2.794-3.313-2.005l-5.519 2.89a2.263 2.263 0 0 0-.458 3.693l5.52 4.929c1.458 1.302 3.77.267 3.77-1.688"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "reviewNothing_svg__d",
    width: 40,
    height: 37,
    x: 64,
    y: 27,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7ED",
    d: "M96.211 27H64.527a4.886 4.886 0 0 1 4.886 4.886V56.42a6.79 6.79 0 0 0 6.79 6.79H96.21a6.79 6.79 0 0 0 6.79-6.79V33.79A6.79 6.79 0 0 0 96.211 27"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#reviewNothing_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 110.356,
    cy: 21.907,
    r: 24.329,
    fill: "#B9C2D1",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D9AE8",
    d: "M78.672 43.765v-.44q0-1.704.862-2.926a6 6 0 0 1 .741-.862q.4-.381.962-.822.6-.46.922-.78a1.7 1.7 0 0 0 .42-.722q.06-.24.06-.481 0-.48-.28-.882a2 2 0 0 0-.721-.54 2.04 2.04 0 0 0-.922-.221q-.962 0-1.583.46-.58.462-.822 1.383l-.1.421-2.965-.761.1-.421q.5-1.985 1.843-3.006 1.363-1.042 3.487-1.042 1.142 0 2.104.34a4.3 4.3 0 0 1 1.643 1.023q.66.621 1.002 1.503.36.86.36 1.843 0 .841-.3 1.483a3.7 3.7 0 0 1-.701 1.082q-.401.44-1.082 1.042-.903.76-1.343 1.382-.42.602-.42 1.523v.441zm1.743 4.709q-.78 0-1.342-.561-.54-.54-.541-1.363 0-.78.54-1.322a1.83 1.83 0 0 1 1.343-.561q.782 0 1.343.56.561.542.561 1.323 0 .782-.541 1.363a1.86 1.86 0 0 1-1.363.561"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#231815",
    strokeMiterlimit: 10,
    strokeWidth: 0.513,
    d: "M25.65 82.03s-8.766-17-17.18-17.038-1.003 11.51 4.522 7.394S12.59 54.746 4.65 52"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.52,
    d: "M114 66 98 82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reviewNothing_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgReviewNothing;